import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'sd-cart-totals-list-item',
  standalone: true,
  templateUrl: './cart-totals-list-item.component.html',
  styleUrls: ['./cart-totals-list-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CartTotalsListItemComponent {
  protected readonly label = input.required<string>();
  protected readonly value = input.required<string | number>();
}
